export const cacheCode = {
  LANGUAGE: 'LanguageCode',
  COUNTRY: 'CountryCode'
}
